import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import LineItemV2 from "../../common/component/lineitem/LineItemV2";
import { ExpandMoreOutlined } from "@mui/icons-material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export default function ItemsRollupView(props) {
  const { items } = props;

  let rollup = {};
  for (const item of items) {
    let key = item.type?.trim();
    if (item.variant) {
      if (item.variant?.size) {
        key = `${item.productId ? item.title : "Custom"} • ${item.variant?.size?.name?.trim()}`;
      }
      /*if (item.variant?.flavor) {
        const flavorVariant = normalizeFlavor(item.variant.flavor);
        key.flavor = flavorVariant.name?.trim();
      }*/
    }

    let o = rollup[key] || { items: [] };
    o.items.push(item);
    rollup[key] = o;
  }

  // convert to arr
  let arr = [];
  for (const [k, v] of Object.entries(rollup)) {
    arr.push({ key: k, items: v.items });
  }
  // sort
  arr.sort((o1, o2) => {
    return o1.key.localeCompare(o2.key);
  });

  return (
    <Box>
      {arr.map((o) => {
        return (
          <Box my={2}>
            <Accordion elevation={0}>
              <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
                <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <Box
                    sx={{
                      minWidth: "40px",
                      width: "40px",
                      height: "40px",
                      border: "1px solid #DDD",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h6">
                      {o.items.reduce((acc, item) => +acc + (+item.quantity || 1), 0)}{" "}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
                      {o.key}
                    </Typography>
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  {o.items.map((i, idx) => {
                    return (
                      <Box
                        p={1}
                        my={1}
                        key={idx}
                        sx={{ display: "flex", gap: "2rem", justifyContent: "space-between" }}
                      >
                        <LineItemV2 item={i} view="min" />
                        <Box>
                          <IconButton component="a" href={`/order/${i.orderId}`} target="_blank">
                            <OpenInNewIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        );
      })}
    </Box>
  );
}
